import {Form, Modal, Row, Spin, Steps} from "antd";
import React, {useEffect, useState} from "react";
import ChooseContractType from "./steps/choose-contract-type";
import CreateOrder from "./steps/create-order";
import {useHistory} from "react-router-dom";
import ReapproveOrder from "./steps/reapprove-order";
import i18n from "../../../i18n";
import ModalGuarantorBeforeContract from "../guarantor-before-contract";
import BelarusEditGuarantor from "../belarus-edit-guarantor";
import { consignorService } from "../../../services/consignor.services";
import { companyService } from "../../../services/company.services";

export default function ModalCreateContractOrder({isShow, setIsShow, legalEntityID, shipperCompanyID, allowContractTypes = ['carriage', 'container'], skipGuarantorPrecheck = false}) {
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [needUpdateInfo, setNeedUpdateInfo] = useState(true);
  const [contractType, setContractType] = useState('');
  const [showGuarantorModal, setShowGuarantorModal] = useState(false);
  const [showBelarusGuarantorModal, setShowBelarusGuarantorModal] = useState(false);
  const [allowRender, setAllowRender] = useState(false);

  const history = useHistory();

  useEffect(() => {
    setCurrentStep(1);
    setContractType('');
    setAllowRender(false);
  }, [isShow]);

  useEffect(() => {
    let mounted = true;
    async function checkGuarantorNeed() {
      if (!isShow) return;
      if (skipGuarantorPrecheck || allowContractTypes.includes('cross_dock')) {
        if (mounted) {
          setAllowRender(true);
          setShowGuarantorModal(false);
          setShowBelarusGuarantorModal(false);
        }
        return;
      }
      try {
        const info = await consignorService.geShipperCompanyInfo(shipperCompanyID);
        let consignorId = null;
        if (info) {
          if (info.Consignor && info.Consignor.Id) consignorId = info.Consignor.Id;
          else if (typeof info.consignorId !== 'undefined') consignorId = info.consignorId;
          else if (typeof info.ConsignorId !== 'undefined') consignorId = info.ConsignorId;
          else if (info.consignor && info.consignor.Id) consignorId = info.consignor.Id;
        }
        if (!consignorId) {
          if (mounted) setAllowRender(true);
          return;
        }
        const premium = await consignorService.getPremiumAccessList(consignorId);
        const payload = (premium && premium.data) ? premium.data : premium;
        let needGuarantor = false;
        if (payload) {
          if (payload.list && typeof payload.list['guarantor_required'] !== 'undefined') {
            needGuarantor = payload.list['guarantor_required'] === true;
          } else if (typeof payload['guarantor_required'] !== 'undefined') {
            needGuarantor = payload['guarantor_required'] === true;
          }
        }
        const legalEntity = await companyService.getLegalEntityData(legalEntityID);
        const isProprietor = !!(
          (legalEntity && legalEntity.IsProprietorType) ||
          (legalEntity && legalEntity.isProprietor) ||
          (legalEntity && legalEntity.OrgForm && legalEntity.OrgForm.IsProprietorType) ||
             (legalEntity && legalEntity.OrgFormId === 16) || //ИП Белорусии
          (legalEntity && legalEntity.OrgFormId === 27)  //ИП Казахстана
        );
        const guarantorWrited = !!(legalEntity && 
            legalEntity && legalEntity.GuarantorFirstName &&
            legalEntity && legalEntity.GuarantorPassportNumber) 
            
        if (mounted && needGuarantor && !isProprietor && !guarantorWrited) {
          if (legalEntity && legalEntity.CountryId === 1) {
            setShowBelarusGuarantorModal(false);
            setShowGuarantorModal(true);
            setAllowRender(false);
            return;
          }
          if (legalEntity && legalEntity.CountryId === 3 || legalEntity && legalEntity.CountryId === 6) {
            setShowGuarantorModal(false);
            setShowBelarusGuarantorModal(true);
            setAllowRender(false);
            return;
          }
        }
        if (mounted) {
          setShowGuarantorModal(false);
          setShowBelarusGuarantorModal(false);
          setAllowRender(true);
        }
      } catch (e) {
        if (mounted) setAllowRender(true);
      }
    }
    checkGuarantorNeed();
    return () => { mounted = false; };
  }, [isShow, shipperCompanyID, legalEntityID, skipGuarantorPrecheck]);
  const handleSuccessOrderCreate = () => {
    setIsShow(false);
    setCurrentStep(1);
    if(allowContractTypes.includes('cross_dock')) {
      history.push('/consignor/orders-to-shipper-company');
    } else {
      history.push('/company/orders-to-shipper-company');
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <ChooseContractType
            legalEntityID={legalEntityID}
            shipperCompanyID={shipperCompanyID}
            needUpdate={needUpdateInfo}
            onChooseContract={onChooseContract}
            onNeedReapprove={onNeedReapprove}
            skipGuarantorPrecheck={skipGuarantorPrecheck}
            allowContractTypes={allowContractTypes}
          />
        );
      case 2:
        return (
          <CreateOrder
            legalEntityID={legalEntityID}
            shipperCompanyID={shipperCompanyID}
            needUpdate={needUpdateInfo}
            contractType={contractType}
            onSuccess={handleSuccessOrderCreate}
          />
        );
      case 'reapprove':
        return (
          <ReapproveOrder
            legalEntityID={legalEntityID}
            shipperCompanyID={shipperCompanyID}
            needUpdate={needUpdateInfo}
            onSuccess={handleSuccessOrderCreate}
          />
        )
      default:
        return <div/>;
    }
  };

  const onChooseContract = (contractType) => {
    setContractType(contractType);
    setCurrentStep(2);
    setNeedUpdateInfo(true);
  };

  const onNeedReapprove = () => {
    setContractType('');
    setCurrentStep('reapprove');
    setNeedUpdateInfo(true);
  }

  return (
    <Modal
      title={i18n.t('modals.modalCreateContractOrder.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={null}
    >
      <ModalGuarantorBeforeContract
        visible={showGuarantorModal && !skipGuarantorPrecheck}
        onClose={() => setShowGuarantorModal(false)}
        legalEntityId={legalEntityID}
        onSaved={() => { setShowGuarantorModal(false); setAllowRender(true); }}
      />
      <BelarusEditGuarantor
        isShow={showBelarusGuarantorModal && !skipGuarantorPrecheck}
        setIsShow={setShowBelarusGuarantorModal}
        legalEntityId={legalEntityID}
        onSaved={() => { setShowBelarusGuarantorModal(false); setAllowRender(true); }}
      />
      <Spin spinning={loading || !allowRender} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={16} className="add-padding-10">
          <Steps current={currentStep - 1} size="small" progressDot className="dots-custom">
            <Steps.Step title={i18n.t('modals.modalCreateContractOrder.steps.step1.title')}/>
            <Steps.Step title={i18n.t('modals.modalCreateContractOrder.steps.step2.title')}/>
          </Steps>
        </Row>
        {allowRender ? (
          <Form onSubmit={() => {}}>
            {renderCurrentStep()}
          </Form>
        ) : null}
      </Spin>
    </Modal>
  );
}
